import React from "react";
import faq_icon from "../../assets/images/Faqline.png";
import styles from "./DesignBox.module.css";
import { linkProfile } from "../../constants";

const LinkSocialAppIcon = () => {
  return (
    <a
      href={linkProfile}
      target="_blank"
      rel="noopener noreferrer"
      style={{ textDecoration: "none" }}
      className={styles.dbx_bottom_line_main_container}
    >
      <img className={styles.dbx_line_icon} src={faq_icon} alt="line" />
      <div className={styles.dbx_line_text}>お問い合わせ</div>
    </a>
  );
};

export default LinkSocialAppIcon;
